import $ from "jquery";
import axios from "axios";

const getMJLCodeFromAPI = async (mjmlCode) => {
  var data = JSON.stringify({ mjml: mjmlCode });
  var config = {
    method: "post",
    url: "https://api.mjml.io/v1/render",
    headers: {
      Authorization:
        "Basic NGFlOWI0MjAtOTkxMi00NzcwLTkxZDUtOGMyNjhkMTFiYmZkOmYyMTNlMjUwLWM3ZjktNGUyNS05ZDMyLWNmODk0MjUxYzNjMw==",
      "Content-Type": "application/json"
    },
    data: data
  };

  // axios(config)
  //   .then(function (response) {
  //     console.log(response.data.html);
  //   })
  //   .catch(function (error) {
  //     console.log(error);
  //   });

  // https://stackoverflow.com/questions/48980380/returning-data-from-axios-api
  // create a promise for the axios request
  const promise = axios(config);

  // using .then, create a new promise which extracts the data
  const dataPromise = promise.then((response) => response.data);

  // return it
  return dataPromise;
};

const parseMJMLtoHTML = async (mjmlCode) => {
  //for mjml:
  const response = await getMJLCodeFromAPI(mjmlCode);

  if (!response.html) {
    alert("bad template code!");
  }

  // const htmlOutput = mjml2html(mjmlCode);
  // var htmlDoc = new DOMParser().parseFromString(htmlOutput.html, "text/html");
  var htmlDoc = new DOMParser().parseFromString(response.html, "text/html");

  //for html:
  // var htmlDoc = new DOMParser().parseFromString(mjmlCode, "text/html");

  var head = htmlDoc.getElementsByTagName("head");

  var body = htmlDoc.getElementsByTagName("body");

  var preheader = null;
  //when ther's a preheader, there's 2 divs , so get the second
  // var wrapperSelector = ">div";
  if ($(">div", body).length > 1) {
    preheader = $(">div", body).first().get();
    $(">div", body).first().remove();
  }
  // var html = ($(body))

  $("div", body)
    .contents()
    .filter(function () {
      return this.nodeType === 8;
    })
    .each(function (i, e) {
      var nodeValue = e.nodeValue;
      /**
          part 1: split comments and wrap them in nodes
          **/
      //mjml adjacent blocks have comments that don't restart
      //this separates the closing table comment into 2
      var parts = nodeValue.split("</table>");
      var newNodeValue = nodeValue;
      if (parts.length) {
        newNodeValue = "";
        var part1 = parts[0] + "</table><![endif]";
        newNodeValue += part1;
        e.nodeValue = newNodeValue;
        var nodey = $(e).wrapAll("<comment></comment>").parent();
        if (parts[1] && parts[1].trim() !== "<![endif]") {
          newNodeValue = "";
          var part2 = "<!--[if mso | IE]>" + parts[1];
          newNodeValue += part2;
          var nextComment = document.createElement("comment");
          nextComment.innerHTML = newNodeValue;
          $(nodey).after(nextComment);
        }
      }
    });

  /**
        part 2 : remove empty text nodes (node 3)
        **/
  $("div", body)
    .contents()
    .each(function (i, e) {
      if (e.nodeType === 3) {
        if (e.nodeValue.trim() === "") {
          e.remove();
        }
      }
    });

  /**
   ** part 3: loop through the nodes
   * and find dives surrounded by 2 comment nodes
   * wrap nodes number 1 surroundded by 2 node 8s
   ***/

  $("div", body)
    .contents()
    .each(function (i, e) {
      if (e.nodeType === 1) {
        if (
          e.nextSibling &&
          e.nextSibling.nodeName === "COMMENT" &&
          e.previousSibling &&
          e.previousSibling.nodeName === "COMMENT"
        ) {
          //wrap the nodes
          var collection = [];

          var clone1 = e.previousSibling.cloneNode(true);
          var clone2 = e.cloneNode(true);
          var clone3 = e.nextSibling.cloneNode(true);

          collection.push(clone1);
          collection.push(clone2);
          collection.push(clone3);

          var container = document.createElement("section");
          // container.insertBefore(collection[0]);
          for (i = 0; i < collection.length; i++) {
            container.appendChild(collection[i]);
          }

          $(e.previousSibling).remove();
          $(e.nextSibling).remove();
          e.replaceWith(container);
        }
      }
    });

  /**
    part 4: anything child not wrapped in a section
    must be wrapped
  **/
  $(">div", body)
    .children()
    .each(function (index) {
      if ($(this).prop("tagName").indexOf("TABLE") > -1) {
        $(this).wrap("<section></section>");
      }
    });

  // console.log(body[0].outerHTML);
  var bodyClone = body[0].cloneNode(true);
  bodyClone.innerHTML = "";
  var bodyAttributes = $(bodyClone).prop("attributes");

  //get wrapper
  var wrapper = $(">div", body).get();
  var wrapperAttributes = "";

  if (wrapper.length) {
    var wrapperClone = wrapper[0].cloneNode(true);
    wrapperClone.innerHTML = "";
    wrapperAttributes = $(wrapperClone).prop("attributes");
  }

  // var wrapperToReplace = htmlDoc.getElementById('newsletter')
  // wrapper.toReplace.innerHTML = wrapper
  return {
    htmlDoc: htmlDoc.firstElementChild,
    head: head,
    preheader: preheader,
    bodyAttributes: bodyAttributes,
    wrapperAttributes: wrapperAttributes
  };
};
export default parseMJMLtoHTML;
